import React, { useState, useEffect } from "react";
import styled from "styled-components";
import {
    Typography,
    Table,
    TableHead,
    TableBody,
    TableCell,
    TableRow,
    TablePagination,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
    IconButton,
    Button,
    Fade
} from "@material-ui/core";

import {
    Add as AddIcon,
    Remove as RemoveIcon,
    RemoveRedEye as ViewIcon,
    Edit as EditIcon
} from "@material-ui/icons";

import { TablePaginationHelper, noImg } from "vrcore-dashboard/dist/utilities";
import { StyledContent } from "../../../styles";

import {
    AddModal,
    RemoveModal,
    AddCustomQualificationModal,
    EditCustomQualificationModal,
    ViewValidUsersModal
} from "./";

const InfoImgDiv = styled.div`
    display: flex;
    width: fit-content;
`;
const TitleTypography = styled(Typography)`
    margin-left: 30px !important;
    margin-top: 10px !important;
    width: 300px;
`;

const AddCustomQualificationButton = styled(Button)`
    margin-left: 30px !important;
    height: fit-content !important;
    margin-top: 10px !important;
`;
const CustomQualificationInfoDiv = styled.div`
    margin-left: 30px;
    margin-top: 15px;
`;
export default props => {
    const [currentTable, setCurrentTable] = useState(props.currentTable);
    const [qualifications, setQualifications] = useState(
        props.filteredQualifications
    );
    const [categories, setCategories] = useState(props.categories);
    const [category, setCategory] = useState(props.category);
    const [addModalState, setAddModalState] = useState(false);
    const [selectedQualification, setSelectedQualification] = useState(false);
    const [removeModalState, setRemoveModalState] = useState(false);
    const [
        customQualificationModalState,
        setCustomQualificationModalState
    ] = useState(false);
    const [
        editCustomQualificationModalState,
        setEditCustomQualificationModalState
    ] = useState(false);
    const [
        selectedCustomQualification,
        setSelectedCustomQualification
    ] = useState(false);

    useEffect(() => {
        setCurrentTable(props.currentTable);
        setQualifications(props.filteredQualifications);
        setCategories(props.categories);
        setCategory(props.category);
    }, [
        props.currentTable,
        props.filteredQualifications,
        props.categories,
        props.category
    ]);
    return (
        <StyledContent>
            {qualifications && categories && (
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>
                                <div style={{ display: "flex" }}>
                                    <FormControl
                                        style={{
                                            minWidth: 250,
                                            marginBottom: 10
                                        }}
                                    >
                                        <InputLabel>Select Category</InputLabel>
                                        <Select
                                            value={category}
                                            onChange={event =>
                                                props.setCategory(
                                                    event.target.value
                                                )
                                            }
                                        >
                                            <MenuItem value="all_categories">
                                                All Categories
                                            </MenuItem>
                                            {Object.keys(categories).map(
                                                (key, index) => {
                                                    return (
                                                        <MenuItem
                                                            value={
                                                                categories[key]
                                                            }
                                                            key={key}
                                                        >
                                                            {categories[key]}
                                                        </MenuItem>
                                                    );
                                                }
                                            )}
                                        </Select>
                                    </FormControl>
                                    {category === "Custom Qualifications" &&
                                        (currentTable === "available") ===
                                            true &&
                                        props.canCreate && (
                                            <Fade
                                                in={
                                                    (category ===
                                                        "Custom Qualifications" &&
                                                        currentTable ===
                                                            "available") ===
                                                    true
                                                        ? true
                                                        : false
                                                }
                                            >
                                                <div
                                                    style={{ display: "flex" }}
                                                >
                                                    <AddCustomQualificationButton
                                                        disabled={
                                                            props.numberOfCustomQualifications ===
                                                            10
                                                                ? true
                                                                : false
                                                        }
                                                        onClick={() =>
                                                            setCustomQualificationModalState(
                                                                true
                                                            )
                                                        }
                                                        variant="contained"
                                                        color="primary"
                                                    >
                                                        Add Qualification
                                                    </AddCustomQualificationButton>
                                                    <CustomQualificationInfoDiv>
                                                        <Typography variant="caption">
                                                            Max 10
                                                        </Typography>
                                                        <Typography variant="caption">
                                                            Current{" "}
                                                            {
                                                                props.numberOfCustomQualifications
                                                            }
                                                        </Typography>
                                                    </CustomQualificationInfoDiv>
                                                </div>
                                            </Fade>
                                        )}
                                </div>
                            </TableCell>
                            <TablePagination
                                colSpan={3}
                                ActionsComponent={TablePaginationHelper}
                                count={qualifications.length}
                                rowsPerPage={props.rowCount}
                                page={props.pageIndex}
                                onChangePage={(event, page) => {
                                    props.setPageIndex(page);
                                }}
                                onChangeRowsPerPage={event => {
                                    props.setRowCount(event.target.value);
                                }}
                                rowsPerPageOptions={[25, 50]}
                            />
                        </TableRow>
                        <TableRow>
                            <TableHeadCell text="Title" />
                            <TableHeadCell text="Category" />
                            {currentTable === "required" && (
                                <TableCell>
                                    <Typography variant="body2">
                                        <b>Completed</b>
                                    </Typography>
                                    <Typography variant="caption">
                                        Out Of {props.totalValidUsers} Users
                                    </Typography>
                                </TableCell>
                            )}
                            <TableHeadCell text="Action" />
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {qualifications
                            .slice(
                                props.pageIndex * props.rowCount,
                                props.pageIndex * props.rowCount +
                                    props.rowCount
                            )
                            .map((qualification, index) => {
                                return (
                                    <TableRow key={index}>
                                        <TableCell>
                                            <InfoImgDiv>
                                                <img
                                                    src={
                                                        qualification.qualification_valid_img ===
                                                        ""
                                                            ? noImg
                                                            : qualification.qualification_valid_img
                                                    }
                                                    alt="Qualification Icon"
                                                    style={{ height: 50 }}
                                                />
                                                <TitleTypography variant="body2">
                                                    <b>
                                                        {" "}
                                                        -{" "}
                                                        {
                                                            qualification.qualification_title
                                                        }
                                                    </b>
                                                </TitleTypography>
                                            </InfoImgDiv>
                                        </TableCell>
                                        <TableCell>
                                            <Typography variant="body2">
                                                <b>
                                                    {
                                                        qualification.qualification_category
                                                    }
                                                </b>
                                            </Typography>
                                        </TableCell>
                                        {currentTable === "required" && (
                                            <TableCell>
                                                <div
                                                    style={{ display: "flex" }}
                                                >
                                                    <Typography
                                                        style={{
                                                            marginRight: 30,
                                                            marginTop: "auto",
                                                            marginBottom: "auto"
                                                        }}
                                                        variant="title"
                                                    >
                                                        <b>
                                                            {props.usersPerQualification &&
                                                                props.usersPerQualification.map(
                                                                    qualInfo => {
                                                                        if (
                                                                            qualInfo.qualification_id ===
                                                                            qualification.qualification_id
                                                                        ) {
                                                                            return qualInfo.completed;
                                                                        } else
                                                                            return null;
                                                                    }
                                                                )}
                                                        </b>
                                                    </Typography>
                                                    <IconButton
                                                        onClick={() => {
                                                            props.setViewValidUsersModalInfo(
                                                                true,
                                                                qualification.qualification_id
                                                            );
                                                        }}
                                                        style={{
                                                            color: "indigo",
                                                            border:
                                                                "1px solid indigo"
                                                        }}
                                                    >
                                                        <ViewIcon />
                                                    </IconButton>
                                                </div>
                                            </TableCell>
                                        )}
                                        <TableCell>
                                            {currentTable === "required" &&
                                                props.canUpdate && (
                                                    <IconButton
                                                        onClick={() => {
                                                            setRemoveModalState(
                                                                true
                                                            );
                                                            setSelectedQualification(
                                                                qualification
                                                            );
                                                        }}
                                                        style={{
                                                            color: "red",
                                                            border:
                                                                "1px solid red"
                                                        }}
                                                    >
                                                        <RemoveIcon />
                                                    </IconButton>
                                                )}
                                            {currentTable === "available" &&
                                                props.canUpdate && (
                                                    <IconButton
                                                        onClick={() => {
                                                            setAddModalState(
                                                                true
                                                            );
                                                            setSelectedQualification(
                                                                qualification
                                                            );
                                                        }}
                                                        style={{
                                                            color: "green",
                                                            border:
                                                                "1px solid green"
                                                        }}
                                                    >
                                                        <AddIcon />
                                                    </IconButton>
                                                )}
                                            {(qualification.qualification_category &&
                                                category) ===
                                                "Custom Qualifications" &&
                                                currentTable === "available" &&
                                                props.canUpdate && (
                                                    <IconButton
                                                        onClick={() => {
                                                            setEditCustomQualificationModalState(
                                                                true
                                                            );
                                                            setSelectedCustomQualification(
                                                                qualification
                                                            );
                                                        }}
                                                        style={{
                                                            color: "indigo",
                                                            border:
                                                                "1px solid indigo",
                                                            marginLeft: 15
                                                        }}
                                                    >
                                                        <EditIcon />
                                                    </IconButton>
                                                )}
                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                    </TableBody>
                </Table>
            )}
            <AddModal
                isOpen={addModalState}
                addQualification={props.addQualification}
                qualification={selectedQualification}
                setModalState={state => setAddModalState(state)}
            />
            <RemoveModal
                isOpen={removeModalState}
                removeQualification={props.removeQualification}
                qualification={selectedQualification}
                setModalState={state => setRemoveModalState(state)}
            />
            <AddCustomQualificationModal
                isOpen={customQualificationModalState}
                setModalState={() => setCustomQualificationModalState(false)}
                newQualificationInfo={props.newQualificationInfo}
                createCustomQualification={props.createCustomQualification}
            />
            <EditCustomQualificationModal
                isOpen={editCustomQualificationModalState}
                setModalState={() => {
                    setEditCustomQualificationModalState(false);
                    setSelectedCustomQualification(false);
                }}
                qualification={selectedCustomQualification}
                editCustomQualification={props.editCustomQualification}
            />
            <ViewValidUsersModal
                modalInfo={props.viewValidUsersModalInfo}
                setModalInfo={props.setViewValidUsersModalInfo}
                qualificationInfo={props.viewQualificationModalUserInfo}
            />
        </StyledContent>
    );
};

const TableHeadCell = ({ text }) => {
    return (
        <TableCell>
            <Typography variant="body2">
                <b>{text}</b>
            </Typography>
        </TableCell>
    );
};
